import request from '@/utils/request'
import {
  isEmpty
} from '@/utils/tool'
import Vue from 'vue';
import VueCookies from "vue-cookies";

Vue.use(VueCookies);
var _url2 = process.env.VUE_APP_PUBLIC_PORT
import { getCookieToken } from '@/utils/tool'

//返回接口地址
export function url1() {
  return _url2
}
//返回保存图片路径
export function returnSaveFile() {
  return _url2 + "/yzdservice/common/saveFileYs";
}
//返回回显图片路径
export function returnShowPic() {
  return _url2 + "/yzdservice/common/showPic?picUrl=";
}

//返回回显图片路径（根据证号获取pdf再转换的图片流）
export function returnShowPicByPdf(xkzBh) {
  return _url2 + '/yzdservice/api/enterprise/credentials/common/downloadImgno/' + xkzBh;
}

//获取token
export function getToken() {
  return getCookieToken()
}

export function getAccess() {
  const access = getCookieToken()
  if (isEmpty(access)) {
    return access
  } else {
    return access.slice(7)
  }
}

export function downloadPdf(xkzBh, xkzId) {
  return url1() + '/yzdservice/api/enterprise/credentials/common/downloadPdf/' + xkzBh +'/'+ xkzId + '?access=' + getAccess()
}


//获取导航
export function getnav() {
  return request({
    method: 'get',
    url: '/organization/api/auth/author'
  })
}
//获取个人认证信息
export function getgrrzxx() {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/intoGrsmrz'
  })
}

//
export function saveZcxxAll(type) {
  return request({
    method: 'post',
    url: '/yzdservice/register/user/'+ type +'/saveZcxxAll'
  })
}

export function qyxxZzsp() {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/qyxxZzsp'
  })
}
// 下载附件
export function downloadPic(fjUrl) {
  return request({
    method: 'get',
    url: '/yzdservice/common/showPic?picUrl='+fjUrl,
    responseType: 'blob'
  })
}

//获取籍贯树
export function getjg() {
  return request({
    method: 'get',
    url: '/yzdservice/common/getXzqh'
  })
}


export function zhuce(data, type) {
  return request({
    method: 'post',
    url: '/yzdservice/register/user/' + type + '/saveGrsmrz',
    data: data
  })
}
//获取kv
export function getkv(name) {
  return request({
    method: 'get',
    url: '/yzdservice/common/selDictData?dictType=' + name
  })
}

export function qyxxBtg() {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/qyxxBtg'
  })
}

// step4
//查询化学品信息
export function gethxpMes(data, type) {
  return request({
    method: 'post',
    url: '/yzdservice/register/user/' + type + '/selHxpxx',
    data: data
  })
}
//查询化学品tree
export function getHxpTree() {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/getHxpTree'
  })
}
//单条删除化学品信息
export function deletehxpMes(data, type) {
  return request({
    method: 'delete',
    url: '/yzdservice/register/user/' + type + '/removeHxpxx/' + data
  })
}
//单条保存化学品信息
export function saveHxpxx(data, type) {
  return request({
    method: 'post',
    url: '/yzdservice/register/user/' + type + '/saveHxpxx',
    data: data
  })
}

// 查询单位附件table信息
export function getFjTableMes(type, data) {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/' + type + '/selFjsjxxByZjlx?zjlx=' + data
  })
}
//根据table id查询表单信息
export function getFjTableMesById(type, data) {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/' + type + '/selFjxxByFjsjId?sjxxId=' + data
  })
}
//改变状态
export function changeFjStatus(type, data) {
  return request({
    method: 'post',
    url: '/yzdservice/register/user/' + type + '/changeFjsjxxStatus',
    data: data
  })
}
//获取已有的证件类型
export function getFjType(type) {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/' + type + '/getDwxxZjlxs'
  })
}
// 查询单位附件信息
export function getFjMes(type) {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/' + type + '/selDwfjxx'
  })
}
// 保存单位附件信息
export function saveFjMes(data, type) {
  return request({
    method: 'post',
    url: '/yzdservice/register/user/' + type + '/saveQyrzFjxx',
    data: data
  })
}

//删除许可证模块
export function deleteFjMes(data, type) {
  return request({
    method: 'post',
    url: '/yzdservice/register/user/' + type + '/removeHxpFjmk',
    data: data
  })
}

//删除弹窗列表信息
export function deleteImageMes(data, type) {
  return request({
    method: 'delete',
    url: '/yzdservice/register/user/' + type + '/removeQyrzFjxx/' + data
  })
}

///-----------------------------------------法人/经营者----------------------------------
// 获取法人/经营者认证信息 new
export function getfrrzxx(curSubmitStatus) {
  return request({
    method: 'get',
    url: `/yzdservice/register/user/` + `${curSubmitStatus}` + `/selFrxx `
  })
}
// 获取法人/经营者认证信息 (已提交)
export function getfrrzxxReview() {
  return request({
    method: 'get',
    url: '/yzdservice/register/user/ytj/selFrxx'
  })
}
// 保存法人/经营者信息 new
export function saveFrxx(data, curStatus) {
  return request({
    method: 'post',
    url: `/yzdservice/register/user/` + `${curStatus}` + `/saveFrxx`,
    data: data
  })
}
//----------------------------------------------法人/经营者------------------------------------

//购买证start
//购买证列表
export function getgmzMes(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/enterprise/gmz/list',
    data: data
  })
}
//化学品级联
export function gethxpJl() {
  return request({
    method: 'get',
    url: '/yzdservice/api/enterprise/credentials/common/getHxpCascader'
  })
}
//购买证化学品级联
export function gethxpJlgmz() {
  // return request({
  //   method: 'get',
  //   url: '/yzdservice/api/enterprise/credentials/common/getHxpCascader'
  // })
  return request({
    method: 'get',
    url: '/yzdservice/api/enterprise/gmz/getHxpCascader'
  })
}
//购买证化学品级联(购买录入)
export function gethxpJlgmzLR() {
  return request({
    method: 'get',
    url: '/yzdservice/api/enterprise/credentials/common/getHxpCascader'
  })
}
//购买证化学品级联(购买录入数量单位)
export function getGmzLrSldw(code) {
  return request({
    method: 'get',
    url: `/yzdservice/common/hxpDw/${code}`
  })
}
//添加购买证信息（暂时保存，不校验任何数据）
export function addgmzMesTemp(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/enterprise/gmz/addTemp',
    data: data
  })
}

//添加购买证信息
export function addgmzMes(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/enterprise/gmz/add',
    data: data
  })
}
//获取购买证核销前的相关信息
export function getGmzWriteOffBefore(id) {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/gmz/WriteOffBefore/"+id
  })
}
//获取运输证核销前的相关信息
export function getYszWriteOffBefore(id) {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/transport/WriteOffBefore/"+id
  })
}
//初始化带出许可证信息
export function getgmzyyzzhqtzwMes() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/credentials/common/getCertificate"
  })
}
//根据化学品编码初始化合法使用证件信息
export function getgmzhfsyMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/credentials/common/getHfsyzm?hxpbm=" + data
  })
}
//取消核销
export function qxhxgmzMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/gmz/cancelWriteOff",
    data: data
  })
}
//核销
export function hxgmzMes(data) {
  return request({
    method: 'put',
    url: "/yzdservice/api/enterprise/gmz/WriteOff",
    data: data
  })
}

//购买证选择往来单位
export function selectgmzDwMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/wldw/xsdwlist",
    data: data
  })
}
//根据往来单位id带出信息
export function getgmzDwMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/wldw/detail/" + data
  })
}
//添加往来单位信息
export function addgmzwldwMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/wldw/addOrUpdSave",
    data: data
  })
}
//根据单位名称查询入网信息
export function getgmzwlDwrwMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/wldw/selYzddwByDwmc?dwmc=" + data
  })
}
//根据列表id获取详细信息
export function getgmzDetailMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/gmz/detail/" + data
  })
}
//删除购买证
export function DeletegmzMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/gmz/delete/" + data
  })
}

//删除图片
export function DeleteImage(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/gmz/deletefile/" + data
  })
}
//经办人
export function jbrMes() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/credentials/common/getjbr"
  })
}

//导出
export function exportMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/gmz/excelwriter",
    responseType: 'blob',
    data: data
  })
}
//审批环节
export function getsphjMes(type,data) {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/credentials/common/splc/"+type+"/" + data
  })
}

//购买证列表end------------------------------------------------------

//从业人员start
export function getcyryMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCyry/list",
    data: data
  })
}
//获取从业人员详细信息
export function getcyryDetailMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwCyry/detail/" + data
  })
}

//新增从业人员
export function addcyryMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCyry/addOrUpdSave",
    data: data
  })
}
//状态改变
export function changeztcyryMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCyry/changeZzztBtId",
    data: data
  })
}
//从业人员end

//内部使用退回start

// 内部使用退回列表
export function getNbstMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/list",
    data: data
  })
}
//获取详情
export function getnbsyDetailMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/detail/" + data
  })
}
//新增（暂时保存）
export function addNbstMesTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/addTemp",
    data: data
  })
}
//新增(入库)
export function addNbstMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/add",
    data: data
  })
}
//编辑(暂时保存)
export function editNbstMesTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/editTemp",
    data: data
  })
}
//编辑(入库)
export function editNbstMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/edit",
    data: data
  })
}

/**
 * 将字符串生成sacii
 * @param str
 * @returns {*[]}
 */
export function getcommonpart(str) {
  if (typeof str !== 'string') {
    throw new Error('参数错误');
  }
  const asciiArray = [];
  for (let i = 0; i < str.length; i++) {
    // 逐个字符获取ASCII码（0-255范围）
    asciiArray.push(str.charCodeAt(i));
  }
  return asciiArray;
}

/**
 * 将字符串生成二进制
 * @param data
 * @returns {*}
 */
export  function stringToBinary(str) {
  if (typeof str !== 'string') {
    throw new Error('请传入字符串参数');
  }
  const length = str.length;
  const binary = new Uint8Array(length);
  for (let i = 0; i < length; i++) {
    // 取字符的 Unicode 编码值，超过 255 则取模（确保在字节范围内）
    binary[i] = str.charCodeAt(i) % 256;
  }
  return binary;
  //console.log("hou",Array.from(binary)) //用于打印复制使用
}

export function deletenbsyDetailMes(data) {
  return request({
    method: 'delete',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/delete/" + data
  })
}
//获取仓库信息
export function getnbsyckMes(ckId) {
  if(ckId){
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxByCskc/"+ckId
    })
  }else{
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxByCskc"
    })
  }
}
//获取列表下拉仓库信息
export function getListCkcx() {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwCk/getListCkcx"
  })
}
//状态
export function getnbsyztMes() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enum/rk/ty"
  })
}
//导出
export function exportnbsyMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/excelwriter",
    responseType: 'blob',
    data: data
  })
}
//出库单号下拉
export function getnbsyckdhMes() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/hqsyckdh"
  })
}
//变更前检查
export function nbsybgqjc(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/change",
    data: data
  })
}

export function getywsj(data) {
  return 'bViKdFh{T1mnNodxfTunfU[KPIeJNGp5UWKKWmCmV4OMfVSCd4mtdF[J[1uK[ESndnWFVjuiRWSi'
}



//变更
export function nbsybg(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/yzdRkNbsyth/saveChangeApply",
    data: data
  })
}


//内部使用退回end
//调剂入库-----------------------------------------
export function gettjrkListDetail(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/tjrk/list",
    data: data
  })
}
// 新增
export function addtjrkListDetail(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/tjrk/add",
    data: data
  })
}
// 获取入库状态
export function rkStatusList() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enum/rk/ty"
  })
}
// 列表导出
export function exportList(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/tjrk/excelwriter",
    responseType: 'blob',
    data: data
  })
}
//获取调剂入库详情
export function getTJListById(id) {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/tjrk/detail/" + id
  })
}
// 调剂入库删除
export function deleteTJListItem(id) {
  return request({
    method: 'delete',
    url: '/yzdservice/api/enterprise/tjrk/delete/' + id
  })
}
// 获取单位化学品列表
export function getHXPList() {
  return request({
    method: 'get',
    url: '/yzdservice/api/enterprise/credentials/common/getHxpCascader'
  })
}
// 获取保管员姓名
export function getCkBgyList() {
  return request({
    method: 'get',
    url: '/yzdservice/enterprise/dwCk/getCkxxByCskc'
  })
}
// 调出单位主管行政区划树结构数据
export function getDcdwzggajgTreeList() {
  return request({
    method: 'get',
    url: '/organization/api/dept/tree'
  })
}
// 获取登录名
export function userInfofLogin() {
  return request({
    method: 'get',
    url: "/organization/api/user/userInfo"
  })
}
// 调剂入库编辑保存
export function edittjrkListDetail(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/tjrk/edit",
    data: data
  })
}
//调剂入库变更
export function bjtjrkListDetail(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/tjrk/saveChangeApply",
    data: data
  })
}
//调剂入库-----------------------------------------

//---------------------仓储损益----------------------
//查询
export function getccsyMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/storage/sy/page",
    data: data
  })
}
//删除
export function deleteccsyMes(data) {
  return request({
    method: 'delete',
    url: "/yzdservice/api/storage/sy/draft/" + data
  })
}
//新增（暂时保存）
export function addccsyMesTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/storage/syTemp",
    data: data
  })
}
//新增（提交保存）
export function addccsyMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/storage/sy",
    data: data
  })
}
//编辑（暂时保存）
export function editccsyMesTemp(data) {
  return request({
    method: 'put',
    url: "/yzdservice/api/storage/sy/draftTemp",
    data: data
  })
}
//编辑（提交保存）
export function editccsyMes(data) {
  return request({
    method: 'put',
    url: "/yzdservice/api/storage/sy/draft",
    data: data
  })
}
//变更
export function changeccsyMes(data) {
  return request({
    method: 'put',
    url: "/yzdservice/api/storage/sy",
    data: data
  })
}
//变更校验
export function changeYzccsyMes(data) {
  return request({
    method: 'put',
    url: "/yzdservice/api/storage/sy/message",
    data: data
  })
}

//委托单位
export function getccsywtdwMes() {
  return request({
    method: 'get',
    url: "/yzdservice/api/storage/wtDw/list"
  })
}
// 化学品
export function getccsyhxpMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/api/storage/hxp/list/" + data
  })
}
// 获取仓库
export function getccsyckMes(data1, data2) {
  return request({
    method: 'get',
    url: "/yzdservice/api/storage/ckxxAndKcxx/" + data1 + '/' + data2
  })
}

// 获取出库状态
export function ckStatusList() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enum/bb/ty"
  })
}
// 列表导出
export function exportccsyList(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/storage/sy/export",
    responseType: 'blob',
    data: data
  })
}
//---------------------仓储库存-----------------------
//查看列表
export function getCcKc(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/storage/kc/page",
    data: data
  })
}


// ---------------------生产入库------------------------
//查看列表
export function getscrkMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/scrk/list",
    data: data
  })
}
//查看详情根据id
export function getscrkDetailMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwCk/scrk/detail/" + data
  })
}

//新增、编辑（暂时保存）
export function addoreditscrkMesTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/scrk/addOrUpdSaveTemp",
    data: data
  })
}

//新增、编辑（提交申请）
export function addoreditscrkMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/scrk/addOrUpdSave",
    data: data
  })
}
//删除
export function deletescrkMes(data) {
  return request({
    method: 'delete',
    url: "/yzdservice/enterprise/dwCk/scrk/remove/" + data
  })
}
//导出
export function exportscrkList(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/scrk/excelwriter",
    responseType: 'blob',
    data: data
  })
}

//变更
export function changescrkMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/scrk/saveChangeApply",
    data: data
  })
}
//变更校验
export function changeYzscrkMes(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/scrk/changePdkcByScrk",
    data: data
  })
}
//化学品数
export function scrkhxpMes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/credentials/common/getHxpCascader/1"
  })
}

// ---------------------生产入库------------------------
//---------------------使用出库-----------------------
// 使用出库table列表
export function syOutList(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/syck/list",
    data: data
  })
}
// 获取状态下拉
export function statusOptions() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enum/ck/ty"
  })
}
// 新版其他出库 获取状态下拉
export function statusOptionsNew() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enum/ck/crksp"
  })
}
//使用出库化学品
export function syckhxp() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enterprise/credentials/common/getHxpCascader/2"
  })
}
// 通过化学品编码获取仓库下拉
export function ckOptions(data,ckId) {
  if(ckId){ //有仓库主键，则携带
    return request({
      method: "get",
      url: `/yzdservice/enterprise/dwCk/getCkxxAndKcxx/` + data+`/`+ckId
    });
  }else{
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/getCkxxAndKcxx/" + data
    })
  }
}
// 领用人下拉
export function lyrOptions() {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwCk/syck/getLyrList"
  })
}
// 添加使用出库信息（暂时保存）
export function addSyckTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/syck/addOrUpdSaveTemp",
    data: data
  })
}
// 添加使用出库信息（出库）
export function addSyck(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/syck/addOrUpdSave",
    data: data
  })
}
// 添加之前校验
export function beforeAddSyck(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/syck/savePdkcBySyck",
    data: data
  })
}
// 获取当前行的数据
export function getInformationById(curId) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwCk/syck/detail/" + curId
  })
}

//删除
export function deleteSYckListItem(id) {
  return request({
    method: 'delete',
    url: '/yzdservice/enterprise/dwCk/syck/remove/' + id
  })
}
//变更保存前
export function beforeBGForm(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/dwCk/syck/changePdkcBySyck',
    data: data
  })
}
// 出入库数量
export function homeSelectCk() {
  return request({
    method: 'get',
    url: '/yzdservice/enterprise/dwCk/getCkxxByCskc'
  })
}

export function bgSaveForm(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/dwCk/syck/saveChangeApply',
    data: data
  })
}
//导出
export function exportsyckList(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/syck/excelwriter",
    responseType: 'blob',
    data: data
  })
}

//---------------------使用出库-----------------------

//---------------------损耗出库-----------------------
//领用人lyrOptions
// 通过化学品编码获取仓库下拉ckOptions(hxpBm)
//化学品级联 gethxpJl
//获取列表
export function getshcklistMes(data) {
  return request({
    method: 'post',
    url:'/yzdservice/enterprise/dwCk/shck/list',
    data: data
  })
}
//新增（暂时保存）
export function addorsaveshckMesTemp(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/dwCk/shck/addOrUpdSaveTemp',
    data: data
  })
}
//新增（出库）
export function addorsaveshckMes(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/dwCk/shck/addOrUpdSave',
    data: data
  })
}
//详情
export function getshckDetailMes(data) {
  return request({
    method: 'get',
    url: '/yzdservice/enterprise/dwCk/shck/detail/' + data
  })
}
//删除
export function deleteshckMes(data) {
  return request({
    method: 'delete',
    url: '/yzdservice/enterprise/dwCk/shck/remove/' + data
  })
}
//导出
export function exportshckList(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/shck/excelwriter",
    responseType: 'blob',
    data: data
  })
}
//变更保存前
export function changejcshckMes(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/dwCk/shck/changePdkcByShck',
    data: data
  })
}
//变更
export function changeshckMes(data) {
  return request({
    method: 'post',
    url: '/yzdservice/enterprise/dwCk/shck/saveChangeApply',
    data: data
  })
}
//---------------------损耗出库-----------------------
//---------------------企业资质-----------------------
//获取已有的证件类型
export function getqyzzzzlx() {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwZzzjGl/getZjlxs"
  })
}
//根据证件类型获取附件信息列表
export function getqyzzFjmes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwZzzjGl/getFjsjxxByZjlx/" + data
  })
}
//根据id获取附件详细信息
export function getqyzzFjDetailmes(data1, data2) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwZzzjGl/getFjxxByFjsjId/" + data1 + '/' + data2
  })
}

//历史记录
//根据证件类型获取附件信息列表
export function getqyzzHistroyFjmes(data) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwZzzjGl/getHistroyFjxxByZjlx/" + data
  })
}
//根据id获取附件详细信息
export function getqyzzHistroyFjDetailmes(data1, data2) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwZzzjGl/getHistroyFjxxByFjsjId/" + data1 + '/' + data2
  })
}

//---------------------企业资质-----------------------


//---------------------法律法规-----------------------
export function flfgTableList(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/flfg/flfg/page',
    data: data
  })
}
// 获取政策文件
export function zcwjTableList(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/flfg/zcwj/page',
    data: data
  })
}
// 获取文件内容
export function getListItemById(id) {
  return request({
    method: 'get',
    url: `/yzdservice/api/flfg/info/${id}`
  })
}

//获取验证字符
export function getVata() {
  return request({
    url: process.env.VUE_APP_BASE_API + "/yzdservice/common/getVata",
    method: "get"
  });
}


///api/notice/info/{noticeId}
//---------------------政策文件-----------------------
